import * as yup from 'yup';

const validationFields = {
  firstName: yup.string(),
  lastName: yup.string(),
  mls: yup.string().required('validations.realEstateAgentRegistration.mls.required'),
  email: yup
    .string()
    .email('validations.realEstateAgentRegistration.email.invalid')
    .required('validations.realEstateAgentRegistration.email.required')
    .max(50, 'validations.realEstateAgentRegistration.email.maxLength'),
  password: yup
    .string()
    .required('validations.realEstateAgentRegistration.password.required')
    .min(8, 'validations.realEstateAgentRegistration.password.minLength'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'validations.realEstateAgentRegistration.passwordConfirmation.passwordMatch')
    .required('validations.realEstateAgentRegistration.passwordConfirmation.required'),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = {
  firstName: '',
  lastName: '',
  mls: '',
  email: '',
  password: '',
  passwordConfirmation: '',
};



// WEBPACK FOOTER //
// ./src/forms/realEstateAgentRegistrationForm.js